import { Component, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import { AccountService } from 'app/core';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './typeahead-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class TypeaheadFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  public formCtrl = new UntypedFormControl();
  public searchResults: any[] | null;
  public editing: boolean = false;
  public value: any;
  private _originalValue: any;

  constructor(
    private _accountService: AccountService,
    private readonly _cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];

    this._originalValue = this.value;

    this.formCtrl.disable();

    this.formCtrl.valueChanges
      .pipe(takeUntilDestroyed(this.dRef), debounceTime(400), distinctUntilChanged())
      .subscribe((value) => {
        this._accountService.typeaheadSearch(value, this.fieldDef.name).subscribe((response) => {
          this.searchResults = response;
          this._cdRef.markForCheck();
        });
      });
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
      this.formCtrl.enable();
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    this.editing = false;
    this.formCtrl.disable();
  }

  autoCompleteSelected(): void {
    //this.contactForm.patchValue($event.option.value, { emitEvent: false });
  }

  autoCompleteClosed(): void {
    this.onSave();
    this.editing = false;
    this.formCtrl.disable();
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }
}
